import React from 'react';
import { getSessionTypeKind, getSessionTypeShortLabel } from '../../../utils/sessionTypeUtils';

const TONES = {
  competitive: {
    chip: 'bg-primary-light text-primary',
    well: 'bg-primary-light text-primary',
    accent: 'border-l-primary',
  },
  pegBoard: {
    chip: 'bg-team2-light text-team2',
    well: 'bg-team2-light text-team2',
    accent: 'border-l-team2',
  },
  social: {
    chip: 'bg-success-light text-success-dark',
    well: 'bg-success-light text-success-dark',
    accent: 'border-l-success',
  },
  private: {
    chip: 'bg-surface-subtle text-text-secondary',
    well: 'bg-surface-subtle text-text-secondary',
    accent: 'border-l-border-medium',
  },
};

const CompetitiveTypeIcon = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
    <g strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}>
      <path d="M14.5 17.5 3 6V3h3l11.5 11.5" />
      <path d="m13 19 6-6" />
      <path d="m16 16 4 4" />
      <path d="m19 21 2-2" />
      <path d="M14.5 6.5 18 3h3v3l-3.5 3.5" />
      <path d="m5 14 4 4" />
      <path d="m7 17-4 4" />
      <path d="m3 19 2 2" />
    </g>
  </svg>
);

const PegBoardTypeIcon = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M10.25 3.5v6.75L7.25 20.5M13.75 3.5v6.75L16.75 20.5"
    />
    <circle cx="12" cy="11.25" r="2.4" strokeWidth={1.75} />
    <path strokeLinecap="round" strokeWidth={1.75} d="M9.6 11.25h4.8" />
  </svg>
);

const DefaultTypeIcon = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);

export const sessionTypeTone = (session) => TONES[getSessionTypeKind(session)] ?? TONES.competitive;

export function SessionTypeIcon({ session, className = 'h-4 w-4' }) {
  const kind = getSessionTypeKind(session);
  if (kind === 'pegBoard') return <PegBoardTypeIcon className={className} />;
  if (kind === 'competitive') return <CompetitiveTypeIcon className={className} />;
  return <DefaultTypeIcon className={className} />;
}

/** Compact type pill — Competitive, Peg Board, Social, or Private. */
export function SessionTypeChip({ session, className = '' }) {
  const tone = sessionTypeTone(session);
  return (
    <span className={`inline-flex shrink-0 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${tone.chip} ${className}`}>
      {getSessionTypeShortLabel(session)}
    </span>
  );
}
